import { DesignerEntity } from '../../types';
import { ArticleEntity } from 'src/modules/articles';
import { ProductEntity } from 'src/modules/products';

export enum DesignersDetailsActions {
  FetchDetailsBegin = 'DESIGNERS/FETCH_DETAILS/BEGIN',
  FetchDetailsSuccess = 'DESIGNERS/FETCH_DETAILS/SUCCESS',
  FetchDetailsError = 'DESIGNERS/FETCH_DETAILS/ERROR',
  FetchDetailsProductsBegin = 'DESIGNERS/FETCH_DETAILS/PRODUCTS/BEGIN',
  FetchDetailsProductsSuccess = 'DESIGNERS/FETCH_DETAILS/PRODUCTS/SUCCESS',
  FetchDetailsProductsError = 'DESIGNERS/FETCH_DETAILS/PRODUCTS/ERROR',
}

export interface DesignersDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  errorProducts: any;
  isLoadingProducts: boolean;
  isLoadedProducts: boolean;
  designer: DesignerEntity;
  designers: DesignerEntity[];
  articles: ArticleEntity[];
  products: ProductEntity[];
}
